<template>
  <div>
    <van-popup v-model="showPopup" @click-overlay="close" :close-on-click-overlay="false">
      <Border class="popup-content">
        <img slot="title" class="popup-title" src="~@this/assets/title5.png" alt="" />
        <div slot="content" class="local-price">
          <div class="popup-serial">
            您是否需要4S店提<br />
            <span> {{ serialInfo.name }} </span>购车底价
          </div>
          <div class="local-price__row">
            <span class="local-price__row--text">您的称呼：</span>
            <input v-model="userInfo.name" type="text" class="local-price__row--input" />
          </div>
          <div class="local-price__btn top" @click="clickAskPrice"></div>
        </div>
      </Border>
      <div @click="close" class="popup-close"></div>
    </van-popup>
    <van-popup v-model="successPopup" @click-overlay="changeShowSuccessDialog" :close-on-click-overlay="false">
      <img class="success" @click="changeShowSuccessDialog" src="~@this/assets/success.png" alt="" />
      <div @click="changeShowSuccessDialog" class="popup-close"></div>
    </van-popup>
  </div>
</template>

<script>
import { Popup } from 'vant';
import Border from './Border.vue';
export default {
  data() {
    return {
      showPopup: false,
      successPopup: false,
    };
  },
  watch: {
    showAskPriceDialog(val) {
      this.showPopup = val;
    },
    showSuccessDialog(val) {
      this.successPopup = val;
    },
  },

  props: {
    showAskPriceDialog: {
      type: Boolean,
      default: false,
    },
    showSuccessDialog: {
      type: Boolean,
      default: false,
    },
    userInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    serialInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    clickAskPrice() {
      this.$emit('clickAskPrice');
    },
    close() {
      this.$emit('changeShowAskPriceDialog', false);
    },
    changeShowSuccessDialog() {
      this.$emit('changeShowSuccessDialog');
    },
  },
  beforeDestroy() {
    this.close();
  },
  components: {
    [Popup.name]: Popup,
    Border,
  },
};
</script>

<style lang="scss" scoped>
.success {
  width: 655px;
}
.popup {
  &-content ::v-deep {
    width: 700px;
    .border {
      height: 126px;
    }
  }
  &-title {
    height: 30px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 70px;
  }
  &-serial {
    width: 563px;
    height: 186px;
    color: #1b5af1;
    font-size: 44px;
    background: #ffffff;
    margin: 0 auto;
    border-radius: 20px;
    text-align: center;
    padding-top: 30px;
    box-sizing: border-box;
    line-height: 1.5;
    span {
      color: #ff2f40;
    }
  }
}
.local-price {
  padding-top: 20px;
  &__row {
    text-align: center;
    padding-top: 40px;
    color: #ffffff;
    &--text {
      font-size: 32px;
    }
    &--input {
      font-size: 50px;
      width: 270px;
      height: 60px;
      text-align: center;
      background: transparent;
      border: transparent;
      border-bottom: 5px solid #ffffff;
    }
  }
  &__btn {
    width: 389px;
    height: 93px;
    margin: 40px auto 0;
    background: url(~@this/assets/price-btn.png) center/contain no-repeat;
  }
}
</style>
